@if (visible) {
  <div class="staff-portal-preview-bar" role="status" aria-live="polite">
    <span class="staff-portal-preview-bar-text">
      <span class="staff-portal-preview-bar-label">Viewing as student</span>
      <span class="staff-portal-preview-bar-sep" aria-hidden="true">·</span>
      <button type="button" class="staff-portal-preview-bar-action" (click)="onBackToCrm()">
        Back to CRM portal
      </button>
    </span>
  </div>
}
